
(function(){
  /* apparition des blocs */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('nh-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.nh-reveal').forEach(function(el){io.observe(el);});

  /* écriture : on découpe chaque bulle en mots, puis on les fait s'écrire dès que le bloc apparaît */
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  document.querySelectorAll('.nh-write').forEach(function(el){
    var words=[];
    (function walk(node){
      Array.prototype.slice.call(node.childNodes).forEach(function(ch){
        if(ch.nodeType===3){
          var frag=document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(function(t){
            if(t==='') return;
            if(/^\s+$/.test(t)){ frag.appendChild(document.createTextNode(t)); }
            else { var s=document.createElement('span'); s.className='nh-w'; s.textContent=t; frag.appendChild(s); words.push(s); }
          });
          node.replaceChild(frag,ch);
        } else if(ch.nodeType===1 && ch.tagName!=='BR'){ walk(ch); }
      });
    })(el);
    words.forEach(function(w,i){ w.style.transitionDelay=(i*0.035)+'s'; });
  });

  if(reduce){
    document.querySelectorAll('.nh-write').forEach(function(el){ el.classList.add('nh-on'); });
    return;
  }
  var wio=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('nh-on'); wio.unobserve(e.target); } });
  },{threshold:0.25, rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.nh-write').forEach(function(el){ wio.observe(el); });
})();
